module.exports = __webpack_public_path__ + "static/media/mq.9bcc4ffb.svg";